export const ID_LOG_ROCKET = 'v71kgw/paet';
export const ID_RUT_REGEX = /\./gi;